import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './Notification.module.scss';
import icon from '../../Resources/smallIcon.png';
import linkIcon from '../../Resources/link.png';

const Message = ({gameType, email, score, time}) => {
  const { t } = useTranslation();
  let result = '';
  switch(gameType) {
    case 'FixLengthSwype':
      result = t('just_entered_speed_swype', { email: email, time: time / 1000});
      break;
    case 'InfiniteLengthSwype':
      result = t('just_entered_unlimited_swype', { email: email, score: score});
      break;
    case 'InfiniteLengthSwypeIncreasingDifficulty':
      result = t('just_entered_complicated_swype', { email: email, score: score});
      break;
  }
  return (<>{result}</>);
}

const Notification = ({ gameType, time, score, userMaskedEmail }) => {
  const { t } = useTranslation();
  return (
    <div className={s.container}>
      <img src={icon} alt="Notification" />
      <div className={s.right}>
        <p className={s.title}>{t('wow_did_you_see_that')}</p>
        <p className={s.message}>
          <Message
            gameType={gameType}
            email={userMaskedEmail}
            score={score}
            time={time}
          />
        </p>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#">
          {t('can_you_beat_his_result')} <img src={linkIcon} alt="Link" />
        </a>
      </div>
    </div>
  );
};

export default Notification;
